export function formatPermissions(allPermissions: any[]): any {
  let permissionsString: string[] = [];
  allPermissions.forEach((permission) => {
    const buildLabel = (perm, label = "") => {
      let parent = allPermissions.find(
        (parent) => parent.permissionId === perm.parentPermissionId
      );
      if (parent && parent.permissionDescription) {
        // Prepend parent's description to the label, replacing spaces and hyphens
        let parentLabel = parent.permissionDescription
          .toLowerCase()
          .replace(/[\s-]+/g, "_"); // Replace spaces and hyphens with underscores
        // Recursively build the label with the parent's description
        return buildLabel(parent, `${parentLabel}_${label}`);
      }
      return label; // Base case: no parent found, return the accumulated label
    };

    if (permission.parentPermissionId) {
      let currentLabel = permission.permissionDescription
        .toLowerCase()
        .replace(/[\s-]+/g, "_"); // Replace spaces and hyphens with underscores
      permission.label = buildLabel(permission, currentLabel);
    } else {
      permission.label = permission.permissionDescription
        ? permission.permissionDescription.toLowerCase().replace(/[\s-]+/g, "_")
        : "";
    }

    if (permission.canCreate) {
      permissionsString.push(`create_${permission.label}`);
    }
    if (permission.canDelete) {
      permissionsString.push(`delete_${permission.label}`);
    }
    if (permission.canEdit) {
      permissionsString.push(`edit_${permission.label}`);
    }
    if (permission.canEmail) {
      permissionsString.push(`email_${permission.label}`);
    }
    if (permission.canPrint) {
      permissionsString.push(`print_${permission.label}`);
    }
    if (permission.canView) {
      permissionsString.push(`view_${permission.label}`);
    }
    if (permission.canOther) {
      permissionsString.push(`other_${permission.label}`);
    }
  });
  return permissionsString;
}
